import { ValidTimeZone } from '@iotv/iotv-v3-types'
import { IANAZone } from 'luxon'

export const getTZOffsetMins = (ianaZone: ValidTimeZone, date?: Date) => {
  return IANAZone.create(ianaZone).offset(date?.valueOf() ?? Date.now())
}

export const getTZOffsetHours = (ianaZone: ValidTimeZone, date?: Date) => getTZOffsetMins(ianaZone, date) / 60
